/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRRuleListConfiguration
 */
export interface SSRRuleListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof SSRRuleListConfiguration
     */
    brandAndMarkets?: Array<BrandAndMarketListItem> | null;
}

export function SSRRuleListConfigurationFromJSON(json: any): SSRRuleListConfiguration {
    return SSRRuleListConfigurationFromJSONTyped(json, false);
}

export function SSRRuleListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRRuleListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarkets': !exists(json, 'brandAndMarkets') ? undefined : (json['brandAndMarkets'] === null ? null : (json['brandAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
    };
}

export function SSRRuleListConfigurationToJSON(value?: SSRRuleListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarkets': value.brandAndMarkets === undefined ? undefined : (value.brandAndMarkets === null ? null : (value.brandAndMarkets as Array<any>).map(BrandAndMarketListItemToJSON)),
    };
}


